/**
 * Created by razial on 12.12.2023
 */

const ReplaceOldMissionWindow = CleverappsWindow.extend({
    onWindowLoaded: function (locationId) {
        this.locationId = locationId;

        this._super({
            title: Messages.get("ReplaceOldMissionWindow.title"),
            name: "ReplaceOldMissionWindow",
            content: this.createContent(),
            buttons: this.createButtons(),
            closeButton: false,
            notCloseByTouchInShadow: true
        });
    },

    getPerson: function () {
        return {
            role: "king",
            emotion: "happy"
        };
    },

    createContent: function () {
        const styles = cleverapps.styles.ReplaceOldMissionWindow;

        const banner = new cc.Sprite(bundles.replaceoldmissionwindow.urls.banner);

        const name = [
            `TravelBook.title.${this.locationId}`
        ].find((name) => name && Messages.has(name));

        const text = cleverapps.UI.generateOnlyText(Messages.get("ReplaceOldMissionWindow.text", {
            name: Messages.get(name)
        }), cleverapps.styles.FONTS.REPLACE_OLD_MISSION_WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(banner.width, 0);

        return new cleverapps.Layout([banner, text], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createButtons: function () {
        const styles = cleverapps.styles.ReplaceOldMissionWindow.button;

        const restartButton = new cleverapps.UI.Button({
            type: cleverapps.styles.UI.Button.Images.button_green,
            text: Messages.get("ReplaceOldMissionWindow.restart"),
            onClicked: this.close.bind(this),
            width: styles.width,
            height: styles.height
        });

        return [restartButton];
    },

    listBundles: function () {
        return ["replaceoldmissionwindow"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    REPLACE_OLD_MISSION_WINDOW_TEXT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.ReplaceOldMissionWindow = {
    margin: 20,

    button: {
        width: 300,
        height: 100
    }
};
